<template>
  <div class="search-all">
    <div class="search-contain">
      <Header></Header>
      <typeNav></typeNav>
      <div class="addressBox">
        <img src="/image/address.png" alt />
        <span class="span1">当前页面</span>
        <span class="span1">/</span>
        <span class="span1" style="color: rgba(0,0,0,0.4);">{{primaryColName}}</span>
        <span class="span1">/</span>
        <span class="span2">{{secondaryColName}}</span>
      </div>
      <!-- <div class="search-content">
        <div class="content-head">
          <img src="/image/notice.png" alt />
          <span>搜索结果</span>
        </div>
        <div class="content-body" v-for="(item,index) in noticeList" :key="index">
          <div class="content-item">
            <img src="/image/icon1.png" alt />
            <div class="text-box">
              <p class="p1">{{item.head}}</p>
              <p class="p2">发布时间：{{item.data}}</p>
            </div>
          </div>
        </div>
        <div class="content-footer">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="1"
            :page-sizes="[100, 200, 300, 400]"
            :page-size="100"
            layout="total, sizes, prev, pager, next, jumper"
            :total="1000"
          ></el-pagination>
        </div>
      </div>-->
      <detailBox :id="$route.query.id" @handleName="handleName"></detailBox>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Detail",
  data() {
    return {
      //收集用户输入的关键字
      // noticeList: [
      //   {
      //     head:
      //       "习近平致信全国优秀教师代表 向全国广大教师和教育工作者致以节日问候和诚挚祝福",
      //     data: "2023-09-11"
      //   },
      //   {
      //     head:
      //       "习近平致信全国优秀教师代表 向全国广大教师和教育工作者致以节日问候和诚挚祝福",
      //     data: "2023-09-11"
      //   },
      //   {
      //     head:
      //       "习近平致信全国优秀教师代表 向全国广大教师和教育工作者致以节日问候和诚挚祝福",
      //     data: "2023-09-11"
      //   },
      //   {
      //     head:
      //       "习近平致信全国优秀教师代表 向全国广大教师和教育工作者致以节日问候和诚挚祝福",
      //     data: "2023-09-11"
      //   },
      //   {
      //     head:
      //       "习近平致信全国优秀教师代表 向全国广大教师和教育工作者致以节日问候和诚挚祝福",
      //     data: "2023-09-11"
      //   },
      //   {
      //     head:
      //       "习近平致信全国优秀教师代表 向全国广大教师和教育工作者致以节日问候和诚挚祝福",
      //     data: "2023-09-11"
      //   },
      //   {
      //     head:
      //       "习近平致信全国优秀教师代表 向全国广大教师和教育工作者致以节日问候和诚挚祝福",
      //     data: "2023-09-11"
      //   },
      //   {
      //     head:
      //       "习近平致信全国优秀教师代表 向全国广大教师和教育工作者致以节日问候和诚挚祝福",
      //     data: "2023-09-11"
      //   },
      //   {
      //     head:
      //       "习近平致信全国优秀教师代表 向全国广大教师和教育工作者致以节日问候和诚挚祝福",
      //     data: "2023-09-11"
      //   },
      //   {
      //     head:
      //       "习近平致信全国优秀教师代表 向全国广大教师和教育工作者致以节日问候和诚挚祝福",
      //     data: "2023-09-11"
      //   }
      // ]
      primaryColName: "",
      secondaryColName: ""
    };
  },
  methods: {
    handleName(a, b) {
      this.primaryColName = a;
      this.secondaryColName = b;
    }
  }
};
</script>

<style  scoped lang="less">
.search-all {
  // background: #f3f6fa;
  background: linear-gradient(#79c6ff 0%, #b1daf8 59%, #d5ecfe 100%);
  margin: 0 auto;
  width: 100%;
  padding-bottom: 24px;
}
.search-contain {
  width: 1200px;
  margin: 0 auto;
  .addressBox {
    margin: 20px 0;
    display: flex;
    align-items: center;
    img {
      width: 24px;
      height: 24px;
    }
    .span1 {
      margin-left: 8px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
    }
    .span2 {
      margin-left: 8px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #0052d9;
      line-height: 22px;
    }
  }
  .search-content {
    padding: 24px 62px 40px 62px;
    background: #ffffff;
    .content-head {
      padding-bottom: 24px;
      width: 100%;
      display: flex;
      align-items: center;
      border-bottom: 2px solid rgba(18, 68, 155, 0.2);
      img {
        width: 30px;
        height: 30px;
      }
      span {
        margin-left: 5px;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #0052d9;
        line-height: 34px;
      }
    }
    .content-body {
      margin-bottom: 24px;
      .content-item {
        padding: 20px 0;
        display: flex;
        align-items: center;
        border-bottom: 2px solid rgba(18, 68, 155, 0.2);
        img {
          width: 24px;
          height: 24px;
        }
        .text-box {
          margin-left: 8px;
          .p1 {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 22px;
            display: -webkit-box;
            overflow: hidden; /*超出隐藏*/
            text-overflow: ellipsis; /*隐藏后添加省略号*/
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1; /*想显示多少行*/
          }
          .p2 {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 18px;
          }
        }
      }
    }
    .content-footer {
      display: flex;
      justify-content: flex-end;
    }
  }
}

/* 大型桌面端样式 */
@media only screen and (min-width: 993px) {
  .search-all {
    // background: #f3f6fa;
    background: linear-gradient(#79c6ff 0%, #b1daf8 59%, #d5ecfe 100%);
    margin: 0 auto;
    width: 100%;
    padding-bottom: 24px;
  }
  .search-contain {
    width: 1200px;
    margin: 0 auto;
    .addressBox {
      margin: 20px 0;
      display: flex;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
      }
      .span1 {
        margin-left: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
      }
      .span2 {
        margin-left: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0052d9;
        line-height: 22px;
      }
    }
    .search-content {
      padding: 24px 62px 40px 62px;
      background: #ffffff;
      .content-head {
        padding-bottom: 24px;
        width: 100%;
        display: flex;
        align-items: center;
        border-bottom: 2px solid rgba(18, 68, 155, 0.2);
        img {
          width: 30px;
          height: 30px;
        }
        span {
          margin-left: 5px;
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #0052d9;
          line-height: 34px;
        }
      }
      .content-body {
        margin-bottom: 24px;
        .content-item {
          padding: 20px 0;
          display: flex;
          align-items: center;
          border-bottom: 2px solid rgba(18, 68, 155, 0.2);
          img {
            width: 24px;
            height: 24px;
          }
          .text-box {
            margin-left: 8px;
            .p1 {
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #333333;
              line-height: 22px;
              display: -webkit-box;
              overflow: hidden; /*超出隐藏*/
              text-overflow: ellipsis; /*隐藏后添加省略号*/
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1; /*想显示多少行*/
            }
            .p2 {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 18px;
            }
          }
        }
      }
      .content-footer {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
</style>